// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3zZSq","header":"ReportDetails_header__i3FQN","title":"ReportDetails_title__1tyne","left":"ReportDetails_left__33gw4"};